import {api} from 'shared/core';
import {endpoints} from 'main/tools';
import { makeAutoObservable } from 'mobx';

class UserActivationState {
  constructor() {
    makeAutoObservable(this);
  }

  load() {
    setTimeout(
      async () => {
        await api.post(endpoints.USER_ACTIVATIONS.with(this.token));

        window.location = '/';
      }, 1000);
  }

  get token() {
    return window.location.pathname.split('/').at(-1);
  }
}

export default UserActivationState;
